import { Injectable, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { APP_CONST } from '../../constants/app-constants';
import { environment } from 'src/environments/environment';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private shouldRenderSidebarSubject = new BehaviorSubject<boolean>(true);
  shouldRenderSidebar$: Observable<boolean> = this.shouldRenderSidebarSubject.asObservable();
  private routeSubscription!: Subscription;
  routeLinks = APP_CONST.ROUTES_ACCOUNTS;
  accountsMenuItems = [
    { title: APP_CONST.TITLE_HOME, tabKey: 'home', icon: "assets/images/icons.svg#home", activeIcon: "assets/images/icons.svg#homeActive", path: this.routeLinks.home, opacity: 0.5, },
    { title: APP_CONST.TITLE_SCORES, tabKey: 'scores', icon: "assets/images/icons.svg#speedometer", activeIcon: "assets/images/icons.svg#scoreActive", path: this.routeLinks.scores, labelRight: "15 mins" },
    { title: APP_CONST.TITLE_INBOX, tabKey: 'inbox', icon: "assets/images/icons.svg#all-Inbox", activeIcon: "assets/images/icons.svg#inboxActive", path: this.routeLinks.inbox, labelRight: "Real-time" },
    { title: APP_CONST.TITLE_ENGAGEMENT, tabKey: 'engagement', icon: "assets/images/icons.svg#engagement", activeIcon: "assets/images/icons.svg#engagementActive", path: this.routeLinks.engagement, labelRight: "Upto 48 hours" },
    { title: "Relationship View", tabKey: 'relationship', icon: "assets/images/icons.svg#relationship", activeIcon: "assets/images/icons.svg#relationshipActive", path: 'relationship', opacity: 0.5, },
    // currently deactivated
    // {
    //   title: APP_CONST.TITLE_SETTINGS,
    //   icon: "assets/images/settings.svg",
    //   activeIcon: "assets/images/settingActive.svg",


    //   // path: 'settings',
    //   submenu: [
    //     { title: APP_CONST.SUBMENU_TITLE_GENERAL, path: "settings/general" },
    //     { title: APP_CONST.SUBMENU_TITLE_PROJECTS, path: "settings/project" },
    //     {
    //       title: APP_CONST.SUBMENU_TITLE_SUB_ACCOUNT,
    //       // path: "settings/sub-accounts",
    //       submenu: [
    //         {
    //           title: APP_CONST.SUB_ACCOUNT_SUBMENU_TITLE_NOTIFICATIONS,
    //           path: "settings/sub-accounts/notification",
    //         },
    //       ],
    //     },
    //     {
    //       title: APP_CONST.SUBMENU_TITLE_USER_ACCESS,
    //       path: "settings/user-access",
    //     },
    //     {
    //       title: APP_CONST.SUBMENU_TITLE_CONFIGURE_DASHBOARD,
    //       path: "settings/configure-dashboard",
    //     },
    //     {
    //       title: APP_CONST.SUBMENU_TITLE_SECURITY,
    //       path: "settings/security",
    //     },
    //     {
    //       title: APP_CONST.SUBMENU_TITLE_NOTIFICATION,
    //       path: "settings/notification",
    //     },
    //   ],
    // },
  ];
  projectMenuItems: any = [
    // { title: APP_CONST.TITLE_HOME, icon: "assets/images/home.svg", activeIcon: "assets/images/homeActive.svg",path: this.routeLinks.home, opacity: 0.5 },
    { title: APP_CONST.TITLE_SCORES, tabKey: 'scores', icon: "assets/images/icons.svg#speedometer", activeIcon: "assets/images/icons.svg#scoreActive", path: this.routeLinks.scores, labelRight: "15 mins" },
    { title: APP_CONST.TITLE_INBOX, tabKey: 'inbox', icon: "assets/images/icons.svg#projectInbox", activeIcon: "assets/images/icons.svg#projectInboxActive", path: this.routeLinks.inbox, labelRight: "Real-time" },
    { title: APP_CONST.TITLE_OUTBOX, tabKey: 'sent_beta', icon: "assets/images/icons.svg#outbox", activeIcon: "assets/images/icons.svg#outboxActive", path: this.routeLinks.outbox, labelRight: "Beta" },
    { title: APP_CONST.TITLE_ENGAGEMENT, tabKey: 'engagement', icon: "assets/images/icons.svg#engagement", activeIcon: "assets/images/icons.svg#engagementActive", path: this.routeLinks.engagement, labelRight: "Upto 48 hours" },
    // {
    //   title: APP_CONST.TITLE_SETTINGS, 
    //   icon: "assets/images/settings.svg",
    //   activeIcon: "assets/images/settingActive.svg",
    //   path: this.routeLinks.settings,
    //   submenu: [
    //     { title: APP_CONST.SUBMENU_TITLE_PROJECTS, path: "settings/general" },
    //     { title: APP_CONST.SUBMENU_TITLE_CONVERSATION, path: "settings/interaction" },
    //     { title: APP_CONST.SUBMENU_TITLE_CHANNELS, path: "settings/channels" },
    //     { title: APP_CONST.SUBMENU_TITLE_ORGANISATION, path: "settings/organisation" },
    //     { title: APP_CONST.SUBMENU_TITLE_REQUEST, path: "settings/request" },
    //     { title: APP_CONST.SUBMENU_TITLE_ACTION, path: "settings/action" },
    //     { title: APP_CONST.SUBMENU_TITLE_DATASETS, path: "settings/datasets" }
    //   ]
    // }
  ];
  huddleMenu: any = { title: APP_CONST.TITLE_HUDDLE, tabKey: 'huddle', icon: "assets/images/icons.svg#Huddle", activeIcon: "assets/images/icons.svg#HuddleActive", path: this.routeLinks.huddle, }
  actionMenu: any = { title: APP_CONST.TITLE_ACTION, tabKey: 'action_summary_v2', icon: "assets/images/icons.svg#action", activeIcon: "assets/images/icons.svg#ActionActive", path: this.routeLinks.action, labelRight: "15 mins" };
  // menuItems: any = [];
  usersIdList:any = ['pankaj.rajwade@litmusworld.com']
  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  updateSidebarVisibility(shouldRender: boolean) {
    this.shouldRenderSidebarSubject.next(shouldRender);
  }

  getActiveSideMenu(isAccount: boolean, config?: any) {
    let menuItems: any = [];
    let moduleConfigs: any = {};
    if (isAccount) {
      moduleConfigs = (config && !_.isEmpty(config)) ? config : _.get(Helpers, 'moduleConfigs.account.mainMenu', {});
      if (!_.isEmpty(moduleConfigs)) {
        menuItems = _.filter(this.accountsMenuItems, (menu: any) => {
          if (this.checkTabVisiblity(menu.tabKey, moduleConfigs) || menu.tabKey == 'relationship' || menu.tabKey == 'home') {
            return true;
          } else {
            return false;
          }
        })
      } else {
        menuItems = this.accountsMenuItems;
      }
      

    } else {
      moduleConfigs = (config && !_.isEmpty(config)) ? config : _.get(Helpers, 'moduleConfigs.project.mainMenu', {});
      this.projectMenuItems = _.filter(this.projectMenuItems, (menu: any) => {
        return (menu.tabKey !== 'huddle' && menu.tabKey !== 'action_summary_v2')
      })
      // this.menuItems = Helpers.deepClone(this.projectMenuItems)

      // Check if huddle exists in brandDetails.action_management_configuration

      if (!_.isEmpty(moduleConfigs)) {
        _.each(Helpers.deepClone(this.projectMenuItems), (menu: any, index: number) => {
          // Filter out the "Huddle" item if not present for future use
          if (Helpers.isTabVisible(false, menu.tabKey)) {
            // TODO: enable when required configured nam for tabs.
            // tempMenu.title = _.get(Helpers, 'moduleConfigs.' + menu.tabKey + '.title') || tempMenu.title;
            menuItems.push(Helpers.deepClone(menu));
          }
        })
      } else {
        menuItems = this.projectMenuItems;
      }
      if (moduleConfigs?.huddle && moduleConfigs?.huddle.visible) {
        // Show the "Huddle" menu item
        menuItems.push(this.huddleMenu);
      }

      if (moduleConfigs?.action_summary_v2 && moduleConfigs?.action_summary_v2.visible) {
        // Add the "Action" menu item if it exists
        menuItems.push(this.actionMenu);
      }
      const managerId:string = _.get(Helpers,'managerDetails.manager.email_address')
      
      const settings: any = {
        "title": "Settings",
        "tabKey": "settings",
        "icon": "assets/images/icons.svg#settings",
        "activeIcon": "assets/images/icons.svg#settingActive",
        "path": "settings/interaction",
      }
      // comment because this function is not used anymore.
      // if(environment.developers.includes(managerId)){
      //   menuItems.push(settings)
      // }
      
    }

    return menuItems;
  }

  checkTabVisiblity(tabKey: string, moduleConfigs: any) {
    const isTabEnabled = (tabKey && _.has(moduleConfigs, tabKey + '.enabled') && _.get(moduleConfigs, tabKey + '.enabled') == true);
    const isTabVisible = (tabKey && _.has(moduleConfigs, tabKey + '.visible') && _.get(moduleConfigs, tabKey + '.visible') == true);
    return (isTabEnabled && isTabVisible) ? true : false;
  }
  // for redirecting to home page if IDs doen't exist in url
  // updateSidebarVisibility(forceVisibility?: boolean): void {
  //   this.routeSubscription = this.activatedRoute.queryParams.subscribe((params) => {
  //     const accountId = params['account_id'] || null;
  //     const projectId = params['project_id'] || null;
  //     let shouldRender: boolean;

  //     if (forceVisibility !== undefined) {
  //       shouldRender = forceVisibility;
  //     } else if (accountId || projectId) {
  //       shouldRender = true;
  //     } else {
  //       this.router.navigate(['/accounts']);
  //       shouldRender = false;
  //     }
  //     // Update the sidebar visibility state
  //     this.shouldRenderSidebarSubject.next(shouldRender);
  //   });
  // }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
